import { useEffect, useRef, useState } from 'react';
import { Nav } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import SideBarUl from './SideBarUl';
import { Link } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import SideBar4Team from './Sidebar4Team';
import SideBarTariff from '../Tariff';
import conf from '../../conf/conf';
import Logo from './Logo';

const SideBarNav = ({pcSideBarShow, 
                    setPcSideBarShow, 
                    mobSideBarShow, 
                    setMobSideBarShow} ) => {
  
    const { auth } = useAuth();
    const sideBarRef = useRef(null);

    // Стан видимості меню (десктоп і мобільна версії)
    const [ pcSideBarClass, SetPcSideBarClass ] = useState(pcSideBarShow ? 'pc-sidebar' : 'pc-sidebar pc-sidebar-hide');
    const [ mobSideBarClass, SetMobSideBarClass ] = useState(mobSideBarShow ? ' mob-sidebar-active' : '');

    
    // Клік на оверлаї
    const handleOverlayClick = () => {
        setMobSideBarShow(false);
    } 

    const handleSidebarClick = (e) => {
        if (!mobSideBarShow) return;
        if (e?.target?.closest?.('.hide-sidebar')) {
            setMobSideBarShow(false);
        }
    };
 
    // ХУк зміни видимості - змінює стилі 
    useEffect(()=>{
        SetPcSideBarClass(pcSideBarShow ? 'pc-sidebar' : 'pc-sidebar pc-sidebar-hide');
        SetMobSideBarClass(mobSideBarShow ? ' mob-sidebar-active' : '');
    },[pcSideBarShow, mobSideBarShow])

    useEffect(() => {
        if (!mobSideBarShow) return undefined;

        const handleOutsideClick = (event) => {
            if (!sideBarRef.current) return;
            if (!sideBarRef.current.contains(event.target)) {
                setMobSideBarShow(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [mobSideBarShow, setMobSideBarShow]);

    return (
        <>
        <Nav
            ref={sideBarRef}
            className={`${pcSideBarClass} ${mobSideBarClass}`}
            onClick={handleSidebarClick}
        >
            <div className="navbar-wrapper">
                <div className="m-header border-bottom">
                    {conf.saasMode ? <Logo /> : (
                    <Link to="/" >
                    <div className='d-flex align-items-end'>
                    <img src="/voltox/imgs/voltox.webp" style={{width:'50px'}}/>
                    <h2 className='text-info ms-2 mb-0' style={{fontWeight:'300'}}>VOLTOX</h2>    
                    </div>                    
                    </Link>)}
                </div>
                <div className="navbar-content pc-trigger sidebar-navbar-flex">
                    <SimpleBar className="sidebar-menu-scroll" autoHide> 
                        {(auth?.user?.access?.role == 'manager')
                            ? (<SideBarUl setMobSideBarShow={setMobSideBarShow} />)
                            : (<SideBar4Team setMobSideBarShow={setMobSideBarShow} />)}
                    </SimpleBar>

                    {conf.saasMode && auth?.user?.access?.role == 'manager' && <SideBarTariff />}
                </div>
            </div>
        </Nav>  

        {/** оверлай для мобільного меню */}
        {mobSideBarShow && (
        <div className="pc-menu-overlay"
            onClick={handleOverlayClick}></div>
        )}
        </>
    )
}

export default SideBarNav;